import { Box, Button, Grid, Typography } from "@mui/material"
import LogoMobile from "../../assets/img/logo animation.svg"
import LogoWhite from "../../assets/img/LOGO GYROO BRANCO.png"
import HeaderImg from "../../assets/img/lp/Acelere seu sucesso com Gyroo.png"
import CenterImg from "../../assets/img/lp/Diárias que cabem no seu bolso.png"
import { Underline } from "../../components/underline"
import { useEffect, useState } from "react"
import CarSimulationImg from "../../assets/img/modalities/01-simulation.png"
import MotorcycleSimulationImg from "../../assets/img/modalities/02-simulation.png"
import PhoneSimulationImg from "../../assets/img/modalities/03-simulation.png"
import CarImgDisabled from "../../assets/img/modalities/01-disabled.png"
import MotorcycleImgDisabled from "../../assets/img/modalities/02-disabled.png"
import PhoneImgDisabled from "../../assets/img/modalities/03-disabled.png"
import LogoGyroo from "../../assets/img/GYROO logo.png"
import PixNowImg from "../../assets/img/modalities/04-now.png"
import { useLocation, useNavigate } from "react-router-dom"

import { AiOutlineInstagram, AiOutlineWhatsApp } from "react-icons/ai"
import { FiMail } from "react-icons/fi"
import { BsFacebook } from "react-icons/bs"
import { Format, sendToShow } from "../../utils"
import { ModalCEP } from "./modal/cep"
import { LearnMore } from "./learnMore"
import FloatingSupport from "../../components/floatingSupport"



export const LP = () => {
    const navigate = useNavigate()
    const { state } = useLocation()
    const mobileWidth = 700
    const breakWidth = 1000

    const [isClientFlow, setIsClientFlow] = useState(window.location.pathname === "/pix")

    const [disabled, setDisabled] = useState(false)

    const [isMobile, setIsMobile] = useState(window.innerWidth < mobileWidth)
    const [breakComponents, setBreakComponents] = useState(window.innerWidth < breakWidth)

    const [openModalCEP, setOpenModalCEP] = useState(false)
    const [openModalCEPVerify, setOpenModalCEPVerify] = useState(false)
    const [openLocation, setOpenLocation] = useState(false)

    const [alreadyGetLocation, setAlreadyGetLocation] = useState(false)

    const modalities = (disabled || alreadyGetLocation) ? {
        pix: PixNowImg,
        car: CarImgDisabled,
        motorcycle: MotorcycleImgDisabled,
        phone: PhoneImgDisabled
    } : {
        pix: PixNowImg,
        car: CarSimulationImg,
        motorcycle: MotorcycleSimulationImg,
        phone: PhoneSimulationImg
    }

    useEffect(() => {
        window.addEventListener("resize", () => {
            setIsMobile(window.innerWidth < mobileWidth)
            setBreakComponents(window.innerWidth < breakWidth)
        })
    }, [])

    useEffect(() => {
        if (state?.notAllowed) {
            setDisabled(true)
            setTimeout(() => {
                sendToShow("notAllowed", "center")
            }, 500);
        }
    }, [state])

    return (
        <div style={{
            boxSizing: 'border-box',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            minHeight: '100vh',
            padding: '20px'
        }}>
            <img
                src={LogoGyroo}
                alt="logo gyroo"
                style={{
                    maxWidth: '70%',
                    height: 'auto',
                    maxHeight: '80vh'
                }}
            />
        </div>
    )


    return (
        <>
            <FloatingSupport />
            <Grid
                maxWidth={"100vw"}
                height={"auto"}
                minHeight={"100vh"}
                display={"flex"}
                direction={"column"}
                boxSizing={"border-box"}
                sx={{
                    backgroundImage: `url('data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="22" height="22"%3E%3Ccircle cx="${isMobile ? 1.5 : 2}" cy="${isMobile ? 1.5 : 2}" r="${isMobile ? 1.5 : 2}" fill="rgba(0, 0, 0, .06)" /%3E%3C/svg%3E')`,
                    backgroundSize: isMobile ? "10x 10px" : "50px 50px",
                    backgroundColor: "rgba(255, 255, 255, .9)"
                }}
                gap={"0rem"}
            >
                <Grid
                    width={"100%"}
                    height={"auto"}
                    display={"flex"}
                    direction={"column"}
                    boxSizing={"border-box"}
                    padding={"2rem 2rem"}
                    pb={"20rem"}
                    sx={{
                        background: "linear-gradient(180deg, rgba(0, 136, 255, 0.2) 32.9%, rgba(97, 173, 240, 0.2) 74.9%, rgba(255, 255, 255, 0.2) 100%)"
                    }}
                >
                    {/* cabeçalho */}
                    <Grid
                        width={"100%"}
                        height={"auto"}
                        display={"flex"}
                        direction={"row"}
                        justifyContent={"space-between"}
                        alignItems={"flex-start"}
                    >
                        <img
                            src={LogoMobile}
                            alt={"logo"}
                            style={{
                                width: isMobile ? "7.1rem" : "20.6rem",
                                height: isMobile ? "3.3rem" : "12.6rem",
                            }}
                        />

                        {!isClientFlow && <Grid
                            display={"flex"}
                            direction={"row"}
                            gap={".5rem"}
                            alignItems={"center"}
                            flexWrap={"wrap"}
                            justifyContent={"flex-end"}
                        >
                            <Button
                                variant="contained"
                                sx={{
                                    background: "linear-gradient(90deg, #178BF1 24.4%, #1D22E6 100%)",
                                    fontSize: isMobile ? "1.4rem" : "2rem",
                                    fontWeight: "700",
                                    width: isMobile ? "9rem" : "14rem",
                                    height: isMobile ? "3.6rem" : "5.2rem",
                                    display: "inline-block",
                                    lineHeight: isMobile ? "1.2rem" : "2rem",
                                    pt: 0
                                }}
                                onClick={() => navigate("/cliente")}
                            >
                                <span style={{ fontSize: isMobile ? ".7rem" : "1.3rem", }}>Acesso</span>
                                <br />
                                Clientes</Button>

                            <Button
                                variant="contained"
                                sx={{
                                    background: "linear-gradient(90deg, #178BF1 24.4%, #1D22E6 100%)",
                                    fontSize: isMobile ? "1rem" : "1.8rem",
                                    fontWeight: "700",
                                    width: isMobile ? "9rem" : "14rem",
                                    height: isMobile ? "3.6rem" : "5.2rem",
                                    display: "inline-block",
                                    lineHeight: isMobile ? "1.2rem" : "2rem",
                                    pt: 0
                                }}
                                onClick={() => navigate("/parceiro")}
                            >
                                <span style={{ fontSize: isMobile ? ".7rem" : "1.3rem", }}>Acesso</span>
                                <br />
                                Parceiros</Button>
                        </Grid>}
                    </Grid>

                    <Grid
                        width={"100%"}
                        height={"auto"}
                        display={"flex"}
                        direction={"row"}
                        alignItems={"center"}
                        flexWrap={breakComponents ? "wrap-reverse" : "nowrap"}
                        gap={breakComponents ? "2rem" : "0px"}
                    >
                        <Grid
                            width={"100%"}
                            height={"auto"}
                            display={"flex"}
                            direction={"column"}
                            alignItems={breakComponents ? "center" : "flex-start"}
                            gap={"4rem"}
                            pl={breakComponents ? "0px" : "4rem"}
                        >
                            <Typography
                                variant="h1"
                                sx={{
                                    background: "linear-gradient(90deg, #1D22E6 0%, #10126C 100%)",
                                    WebkitBackgroundClip: "text",
                                    WebkitTextFillColor: "transparent",
                                    fontSize: isMobile ? "2rem" : breakComponents ? "3.5rem" : "6.4rem",
                                    fontWeight: 900,
                                    lineHeight: isMobile ? "2.5rem" : breakComponents ? "3.5rem" : "8rem",
                                    fontFamily: "Nexa heavy",
                                    textAlign: breakComponents ? "center" : "start"
                                }}
                            >
                                Acelere seu sucesso com Gyroo!
                            </Typography>

                            <Typography fontSize={isMobile ? "1.6rem" : breakComponents ? "2rem" : "2.8rem"} color="#10126C" textAlign={breakComponents ? "center" : "start"}>
                                Quer receber um PIX para reforçar o caixa da sua empresa? Disponibilizamos o crédito na hora!
                                <br />
                                <br />
                                Sabemos que a falta de recursos pode limitar seu potencial, mas estamos aqui para você dar um Gyroo em seu negócio, com <strong>diárias que cabem no seu bolso!</strong>
                            </Typography>

                            {isClientFlow &&
                                <Button
                                    variant="contained"
                                    sx={{
                                        background: "linear-gradient(90deg, #178BF1 24.4%, #1D22E6 100%)",
                                        fontSize: "2rem",
                                        fontWeight: "600",
                                        maxWidth: "29.4rem",
                                        padding: "4rem 1rem",
                                        animation: "pulse 1s infinite",
                                    }}
                                    onClick={() => {
                                        navigate("/simular" + window.location.search, {
                                            state: {
                                                verified: true
                                            }
                                        })
                                    }}
                                >
                                    <Typography sx={{
                                        fontSize: "2rem",
                                        fontWeight: "600",
                                    }}>
                                        Solicite Seu <u><strong>Crédito</strong></u> Aqui!
                                    </Typography>
                                </Button>
                            }
                        </Grid>

                        <Grid
                            width={"100%"}
                            display={"flex"}
                            justifyContent={"center"}
                            alignItems={"center"}

                        >
                            <img
                                src={HeaderImg}
                                alt="Gyroo! feito para você"
                                style={{
                                    width: breakComponents ? "70%" : "100%",
                                    height: "auto",
                                    maxWidth: "90rem",
                                    minWidth: isMobile ? "90%" : "40rem",
                                    marginTop: breakComponents ? "2rem" : "0px"
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid
                    width={"100%"}
                    height={"auto"}
                    display={"flex"}
                    direction={"row"}
                    alignItems={"flex-end"}
                    flexWrap={breakComponents ? "wrap" : "nowrap"}
                    gap={breakComponents ? "2rem" : "8rem"}
                    padding={`0px ${breakComponents ? 2 : 9}rem`}
                >

                    <Grid
                        width={"100%"}
                        display={"flex"}
                        justifyContent={"center"}
                        alignItems={"center"}

                    >
                        <img
                            src={CenterImg}
                            alt="Gyroo! solicite agora"
                            style={{
                                width: breakComponents ? "70%" : "100%",
                                height: "auto",
                                maxWidth: "90rem",
                                minWidth: isMobile ? "100%" : "40rem",
                                marginBottom: breakComponents ? "4rem" : "-8rem",
                                marginTop: breakComponents ? "-12rem" : "0px"
                            }}
                        />
                    </Grid>

                    <Grid
                        width={"100%"}
                        height={"auto"}
                        display={"flex"}
                        direction={"column"}
                        gap={"4rem"}
                    >
                        <Typography
                            variant="h1"
                            sx={{
                                background: "linear-gradient(90deg, #1D22E6 0%, #10126C 100%)",
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",
                                fontSize: isMobile ? "2.4rem" : breakComponents ? "3.8rem" : "6.4rem",
                                fontWeight: 100,
                                lineHeight: isMobile ? "2.5rem" : breakComponents ? "5rem" : "8rem",
                                fontFamily: "Nexa ExtraLight",
                                textAlign: breakComponents ? "center" : "start"
                            }}
                        >

                            Diárias que<br />
                            <Underline>
                                <Typography
                                    sx={{
                                        background: "linear-gradient(90deg, #1D22E6 0%, #10126C 100%)",
                                        WebkitBackgroundClip: "text",
                                        WebkitTextFillColor: "transparent",
                                        fontSize: isMobile ? "2.4rem" : breakComponents ? "3.8rem" : "6.4rem",
                                        fontWeight: 900,
                                        lineHeight: isMobile ? "4rem" : breakComponents ? "5rem" : "8rem",
                                        fontFamily: "Nexa heavy",
                                        textAlign: breakComponents ? "center" : "start"
                                    }}
                                >cabem no seu bolso</Typography>
                            </Underline>
                        </Typography>

                        <Typography fontSize={isMobile ? "1.6rem" : breakComponents ? "2rem" : "3.2rem"} textAlign={breakComponents ? "center" : "start"} color="#10126C" sx={{ opacity: .5 }}>
                            Com diárias acessíveis e flexíveis, você resolve tudo de forma rápida, prática e sem complicações.
                            <br />
                            <><strong>Temos a solução perfeita para os momentos mais difíceis.</strong></>
                        </Typography>

                        {disabled &&
                            <Typography id="notAllowed" color="#FE7B01" fontSize={isMobile ? "1.6rem" : breakComponents ? "2.2rem" : "3.2rem"} fontWeight={400} fontStyle={"italic"} textAlign={breakComponents ? "center" : "start"}>No momento nossos serviços estão indisponíveis para sua região</Typography>
                        }

                        {isClientFlow &&
                            <Grid
                                display={"flex"}
                                alignItems={"center"}
                                justifyContent={"center"}
                            >
                                <Button
                                    variant="contained"
                                    sx={{
                                        background: "linear-gradient(90deg, #178BF1 24.4%, #1D22E6 100%)",
                                        maxWidth: "29.4rem",
                                        padding: "4rem 1rem",
                                        animation: "pulse 1s infinite",
                                    }}
                                    onClick={() => {
                                        navigate("/simular" + window.location.search, {
                                            state: {
                                                verified: true
                                            }
                                        })
                                    }}
                                >
                                    <Typography sx={{
                                        fontSize: "2rem",
                                        fontWeight: "600",
                                    }}>
                                        Solicite Seu <u><strong>Crédito</strong></u> Aqui!
                                    </Typography>
                                </Button>
                            </Grid>
                        }
                    </Grid>


                </Grid>

                <Box
                    sx={{
                        maxWidth: "100rem",
                        width: "90%",
                        background: "#4C81E61A",
                        minHeight: "11.4rem",
                        alignSelf: "center",
                        borderRadius: "10px",
                        mt: breakComponents ? "2rem" : "8rem",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxSizing: "border-box",
                        padding: "2rem 1rem",
                        mb: isMobile ? "6rem" : "0px"
                    }}
                >
                    <Typography fontSize={"1.4rem"} color="#10126C" fontStyle={"italic"} textAlign={"center"}><span style={{ color: "#FF0000", fontWeight: 700 }}>Atenção:</span> Os <strong>pagamentos</strong> das diárias devem ser realizados <strong>exclusivamente</strong> através da nossa plataforma <strong>www.gyroo.com.br/cliente</strong></Typography>
                </Box>

                <LearnMore
                    breakComponents={breakComponents}
                    isMobile={isMobile}
                />

                <Grid
                    width={"100%"}
                    height={"auto"}
                    display={"flex"}
                    direction={"row"}
                    justifyContent={"space-between"}
                    flexWrap={breakComponents ? "wrap" : "nowrap"}
                    padding={`${breakComponents ? 5 : 12}rem ${breakComponents ? 2 : 9}rem 4rem`}
                    sx={{
                        background: "linear-gradient(0deg, #10126C 0.81%, #1F58C5 59.1%, rgba(38, 95, 203, 0.75) 74.8%, rgba(255, 255, 255, 0.2) 100%)"
                    }}
                    gap={"2rem"}
                >
                    <Grid
                        display={"flex"}
                        direction={"column"}
                        alignItems={breakComponents ? "center" : "flex-start"}
                    >
                        <img
                            src={LogoWhite}
                            alt="logo na cor branco"
                            style={{
                                width: isMobile ? "19.3rem" : breakComponents ? "25rem" : "34.1rem",
                                marginBottom: "1rem"
                            }} />

                        <Typography color="#FFFFFF" fontSize={isMobile ? "1.2rem" : breakComponents ? "1.5rem" : "2rem"} maxWidth={"100rem"} textAlign={breakComponents ? "center" : "justify"}>
                            Gyroo é a plataforma que conecta você às soluções que impulsionam seu negócio e seu crescimento profissional. Solicite o crédito na hora e descubra como podemos facilitar o seu dia a dia. Nosso compromisso é ajudar você a transformar desafios em oportunidades, sempre com diárias que cabem no seu bolso.
                            <br />
                            <br />
                            Não perca tempo! Junte-se à Gyroo e leve seu negócio para o próximo nível!</Typography>

                    </Grid>
                    <Grid
                        display={"flex"}
                        direction={"column"}
                        justifyContent={"space-between"}
                        alignItems={breakComponents ? "center" : "flex-end"}
                        pt={breakComponents ? "4rem" : "8rem"}
                        gap={breakComponents ? "4rem" : "0px"}
                        width={"100%"}
                    >

                        <Grid
                            width={"100%"}
                            display={"flex"}
                            direction={"row"}
                            alignItems={"flex-start"}
                            justifyContent={breakComponents ? "center" : "flex-end"}
                            alignSelf={"center"}
                            gap={"0rem"}
                        >
                            <Grid
                                width={isMobile ? "6rem" : "9rem"}
                                display={"flex"}
                                direction={"column"}
                                alignItems={"center"}
                                gap={".5rem"}
                                component={"a"}
                                href={`https://wa.me/+5555997181093?text=${Format.whatsAppMessage("Olá, gostaria de atendimento")}`}
                                target="_blank"
                                sx={{
                                    textDecoration: "none"
                                }}
                            >
                                <Box
                                    width={isMobile ? "3rem" : "6rem"}
                                    height={isMobile ? "3rem" : "6rem"}
                                    display={"flex"}
                                    alignItems={"center"}
                                    justifyContent={"center"}
                                    sx={{
                                        background: "linear-gradient(180deg, #1D22E6 0%, #61ADF0 100%)",
                                        borderRadius: "5px"
                                    }}
                                >
                                    <AiOutlineWhatsApp size={isMobile ? "1.8rem" : "3.6rem"} color="#FFFFFF" />
                                </Box>
                                <Typography textAlign={"center"} fontSize={isMobile ? "1rem" : "1.5rem"} color="#FFFFFF">WhatsApp</Typography>
                            </Grid>

                            <Grid
                                width={isMobile ? "6rem" : "9rem"}
                                display={"flex"}
                                direction={"column"}
                                alignItems={"center"}
                                gap={".5rem"}
                                component={"a"}
                                href="mailto:gyroo@gyroo.com.br"
                                sx={{
                                    textDecoration: "none"
                                }}

                            >
                                <Box
                                    width={isMobile ? "3rem" : "6rem"}
                                    height={isMobile ? "3rem" : "6rem"}
                                    display={"flex"}
                                    alignItems={"center"}
                                    justifyContent={"center"}
                                    sx={{
                                        background: "linear-gradient(180deg, #1D22E6 0%, #61ADF0 100%)",
                                        borderRadius: "5px"
                                    }}
                                >
                                    <FiMail size={isMobile ? "1.8rem" : "3.6rem"} color="#FFFFFF" />
                                </Box>
                                <Typography textAlign={"center"} fontSize={isMobile ? "1rem" : "1.5rem"} color="#FFFFFF">E-mail</Typography>
                            </Grid>

                            <Grid
                                width={isMobile ? "6rem" : "9rem"}
                                display={"flex"}
                                direction={"column"}
                                alignItems={"center"}
                                gap={".5rem"}
                                component={"a"}
                                href="https://www.instagram.com/gyroo.oficial?igsh=MXdtczJlMmxkMDNvYw=="
                                target="_blank"
                                sx={{
                                    textDecoration: "none"
                                }}

                            >
                                <Box
                                    width={isMobile ? "3rem" : "6rem"}
                                    height={isMobile ? "3rem" : "6rem"}
                                    display={"flex"}
                                    alignItems={"center"}
                                    justifyContent={"center"}
                                    sx={{
                                        background: "linear-gradient(180deg, #1D22E6 0%, #61ADF0 100%)",
                                        borderRadius: "5px"
                                    }}
                                >
                                    <AiOutlineInstagram size={isMobile ? "2rem" : "4rem"} color="#FFFFFF" />
                                </Box>
                                <Typography textAlign={"center"} fontSize={isMobile ? "1rem" : "1.5rem"} color="#FFFFFF">Instagram</Typography>
                            </Grid>

                            <Grid
                                width={isMobile ? "6rem" : "9rem"}
                                display={"flex"}
                                direction={"column"}
                                alignItems={"center"}
                                gap={".5rem"}
                                component={"a"}
                                href="https://www.facebook.com/gyroo.oficial/"
                                target="_blank"
                                sx={{
                                    textDecoration: "none"
                                }}
                            >
                                <Box
                                    width={isMobile ? "3rem" : "6rem"}
                                    height={isMobile ? "3rem" : "6rem"}
                                    display={"flex"}
                                    alignItems={"center"}
                                    justifyContent={"center"}
                                    sx={{
                                        background: "linear-gradient(180deg, #1D22E6 0%, #61ADF0 100%)",
                                        borderRadius: "5px"
                                    }}
                                >
                                    <BsFacebook size={isMobile ? "1.8rem" : "3.6rem"} color="#FFFFFF" />
                                </Box>
                                <Typography textAlign={"center"} fontSize={isMobile ? "1rem" : "1.5rem"} color="#FFFFFF">Facebook</Typography>
                            </Grid>
                        </Grid>

                        <Typography fontSize={isMobile ? "1.2rem" : breakComponents ? "1.5rem" : "2rem"} lineHeight={"3rem"} textAlign={breakComponents ? "center" : "end"} color="#FFFFFF">
                            <strong>Gyroo®</strong>
                            <br />
                            <a href="https://s3.us-east-1.amazonaws.com/static.gyroo.com.br/app/Termos+de+uso+-+GYROO.pdf" target="_blank" style={{ color: "inherit" }}>Termos de Uso</a> | <a href="https://s3.us-east-1.amazonaws.com/static.gyroo.com.br/app/Poli%CC%81tica+de+privacidade+-+GYROO.pdf" target="_blank" style={{ color: "inherit" }}>Politica de Privacidade</a>
                        </Typography>

                        <Typography mt={isMobile ? "-3rem" : "2rem"} fontSize={isMobile ? "1.2rem" : breakComponents ? "1.5rem" : "2rem"} lineHeight={isMobile ? "1.2rem" : "2.5rem"} textAlign={"justify"} color="#FFFFFF" maxWidth={"70rem"}>
                            A Gyroo é uma plataforma digital que atua como correspondente bancário para facilitar o crédito para sua empresa, Razão social: Gyroo S.A., CNPJ: 53.535.398/0001-27, Somos correspondente bancário, seguimos as diretrizes nº 3.954 de 24 de fevereiro de 2011 do Banco Central do Brasil.
                        </Typography>

                        <Typography mt={isMobile ? "-3rem" : "2rem"} fontSize={isMobile ? "1.2rem" : breakComponents ? "1.5rem" : "2rem"} lineHeight={"3rem"} textAlign={breakComponents ? "center" : "end"} color="#FFFFFF">
                            © 2024-2025 Copyright — Todos os direitos reservados
                        </Typography>
                    </Grid>

                </Grid>
            </Grid>

            <ModalCEP open={openModalCEP} onClose={() => setOpenModalCEP(false)} onConfirm={() => setDisabled(true)} />
            <ModalCEP open={openLocation} onClose={() => setOpenLocation(false)} verify onConfirm={(allowed) => {
                if (allowed) {
                    setAlreadyGetLocation(true)
                } else {
                    navigate("/", {
                        state: {
                            notAllowed: true
                        }
                    })
                    window.location.reload()
                }
            }} />

            {/* <ModalLocation open={openLocation} onClose={() => setOpenLocation(false)} onConfirm={() => setAlreadyGetLocation(true)} /> */}
        </>
    )
}